import React from 'react';

export const PrivateIcon = ({ width = 20, height = 20, color = '#5D5D6B' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 7.083h-.833V5.417c0-2.3-1.867-4.167-4.167-4.167a4.168 4.168 0 0 0-4.167 4.167v1.666H5c-.917 0-1.667.75-1.667 1.667v8.333c0 .917.75 1.667 1.667 1.667h10c.917 0 1.667-.75 1.667-1.667V8.75c0-.917-.75-1.667-1.667-1.667ZM7.5 5.417c0-1.384 1.117-2.5 2.5-2.5s2.5 1.116 2.5 2.5v1.666h-5V5.417ZM15 17.083H5V8.75h10v8.333Zm-5-2.5c.917 0 1.667-.75 1.667-1.666 0-.917-.75-1.667-1.667-1.667s-1.667.75-1.667 1.667c0 .916.75 1.666 1.667 1.666Z"
      fill={color}
    />
  </svg>
);
